import { createValidator, required } from 'util/validation'

import { LotacaoResponsavelFormModel } from './model-lotacaoResponsavel'

export const validateEditarLotacaoResponsavel = createValidator<LotacaoResponsavelFormModel>({
  lotacao: [required],
})
